export default {
  data() {
    return {
      questions: [
        {
          id: 1,
          title: 'Как создать вебинар?',
          url: 'https://help.mts-link.ru/article/19740',
        },
        {
          id: 2,
          title: 'Настройка напоминаний для\u00A0участников',
          url: 'https://help.mts-link.ru/article/19735',
        },
        {
          id: 3,
          title: 'Как создать и\u00A0провести тест для\u00A0участников?',
          url: 'https://help.mts-link.ru/article/19747',
        },
        {
          id: 4,
          title: 'Где посмотреть статистику по\u00A0участникам вебинара?',
          url: 'https://help.mts-link.ru/article/19751',
        },
        {
          id: 5,
          title: 'Как подготовить видеозапись вебинара?',
          url: 'https://help.mts-link.ru/article/19783',
        },
        {
          id: 6,
          title: 'Как работать в\u00A0Команде в\u00A0одном личном кабинете?',
          url: 'https://help.mts-link.ru/category/4160',
        },
      ],
    }
  },
}
